import { getPriceChange } from 'client/site-modules/shared/utils/inventory/price-change';
import { isUsed } from 'site-modules/shared/utils/inventory-utils/is-used';
import { isPartnerDealer } from 'site-modules/shared/utils/dealer-details-utils';
import { getEmbeddedLeadFormCta } from 'site-modules/shared/components/inventory/vdp-embedded-lead-form/vdp-embedded-lead-form';
import { getVdpCtas } from 'site-modules/shared/utils/inventory/get-vdp-ctas';

/**
 * Checks if historical price graph promo can be shown.
 * @param {object} vinData
 * @param {object} [location]
 * @return {boolean}
 */
export const getPriceGraphAvailability = (vinData, location) => {
  const { isPriceDrop } = getPriceChange({ vinData });
  const ctas = getVdpCtas({ vinData, location });
  const type = vinData?.type;

  return (
    isUsed(type) &&
    isPartnerDealer(vinData) &&
    !!getEmbeddedLeadFormCta(ctas) &&
    isPriceDrop &&
    vinData.prices?.historicalPricesIsCompliant
  );
};
